import React, {} from 'react';
import {isPc} from '../../utils/util';

function Banner () {


    return (
        <div className="g-banner">
            
            {
                !isPc() && <div className="g-banner-text">*活动时间：6月16日~6月30日</div>
            }
        </div>
    )
}

export default Banner;